import { memo } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { protocolSummaryColumns } from "../../Constants/protocolSummaryColumns";
import { toDateTime } from "../../Services/string.service";
import EmptyData from "../../components/EmptyData";

const DATE_FIELDS = ["oldestProtocolDate"];

function ProtocolSummaryGrid({ gridData }) {
  const { t } = useTranslation();
  const columns = protocolSummaryColumns(t);

  const renderCell = (field, value) => {
    if (DATE_FIELDS.includes(field)) {
      return value ? toDateTime(value) : "";
    }

    return value ?? "";
  };

  if (!Array.isArray(gridData) || gridData.length === 0) {
    return <EmptyData />;
  }

  return (
    <div className="card">
      <div className="table-responsive text-nowrap">
        <table className="table table-grid" id="protocol-summary-grid">
          <thead>
            <tr>
              <th></th>
              {columns.map(({ field, header }) => (
                <th key={field}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody className="table-border-bottom-0">
            {gridData.map((item, index) => (
              <tr key={item.clientId ?? index}>
                <td>
                  <Link
                    to={{
                      pathname: "/protocols",
                      search: new URLSearchParams({
                        clientName: item.clientName ?? "",
                        ...(item.oldestProtocolDate ? { startDate: item.oldestProtocolDate } : {}),
                      }).toString(),
                    }}
                    className="btn btn-sm btn-outline-primary"
                  >
                    {t("PROTOCOL_SUMMARY.PROTOCOLS_LINK")}
                  </Link>
                </td>
                {columns.map(({ field }) => (
                  <td key={field}>{renderCell(field, item[field])}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default memo(ProtocolSummaryGrid);
